module.exports = __webpack_public_path__ + "media/images/google-play-badge-14a9e51f68ef8b7f569d5a9bf27f561c.png";